module.exports = __webpack_public_path__ + "022d7cfa061bd12d401da7f71027db67.svg";